import error from "../../assets/error.png";
import style from "./style.module.css";
import { useNavigate } from "react-router-dom";

const ErrorPage = () => {
  const navigate = useNavigate();

  const returnHome = () => {
    navigate("/home");
  };
  return (
    // <div className={style.wrapper}>
    <section className="grid lg:grid-cols-2 grid-cols-1 lg:gap-6 gap-4 h-full items-center lg:px-8 md:px-8 px-2 lg:py-32 py-12">
      {/* <div className={style.errImage}> */}
      <div className="justify-center lg:flex hidden">
        <img src={error} alt="Error Doctor" />
      </div>
      <div className="lg:text-left text-center">
        <h3 className={style.errHead}>OOPS! PAGE NOT FOUND</h3>
        <p className={style.errSmall}>
          You must have picked the wrong page because I haven't been able to
          connect to the page which you have requested for.
        </p>
        <div className={`${style.homeBttn}`}>
          <button onClick={returnHome} className={`${style.bttnLink} my-2 `}>
            Back to Home
          </button>
        </div>
      </div>
    </section>
  );
};

export default ErrorPage;
